import * as React from 'react';
import clsx from 'clsx';

interface FormLabelProps {
  label: string;
  subtitle: string;
  className?: string;
}

/**
 * FormLabel Component
 * Displays a styled label and subtitle pair for the Create Echo wizard.
 */
export const FormLabel: React.FC<FormLabelProps> = ({ label, subtitle, className }) => (
  <div className={clsx('flex flex-col gap-1', className)}>
    {/* Label: Inter Medium, 16px, 21px LH, #1C1C1C */}
    <label className='font-sans text-16 font-medium leading-21 text-dark-100'>{label}</label>

    {/* Subtitle: Inter Medium, 14px, 27px LH, #737373 */}
    <p className='font-sans text-14 font-medium leading-27 text-gray-530'>{subtitle}</p>
  </div>
);
